import { jsx } from 'react/jsx-runtime';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import styles from './Pagination.styles.esm.js';
import { PaginationItem } from './PaginationItem.esm.js';
import { generatePageRange } from './utils.esm.js';

const PaginationBody = ({ totalPages, currentPage, inverse, buildHref, onPageChange, }) => {
    const { truncation: truncationClasses } = styles({
        inverse,
    });
    const contractionsList = generatePageRange({
        currentPage,
        totalPages,
    });
    const onPageClick = (pageNumber) => (mouseEvent) => {
        if (pageNumber === currentPage || typeof onPageChange !== "function") {
            return;
        }
        onPageChange(pageNumber, mouseEvent);
    };
    return contractionsList.map((page, index) => {
        const pageNumber = Number(page);
        if (isNaN(pageNumber)) {
            return (jsx(NavigationMenu.Item, { "aria-hidden": "true", children: jsx("span", { className: truncationClasses(), children: page }) }, `...${index}`));
        }
        return (jsx(PaginationItem, { inverse: inverse, buildHref: buildHref, isCurrentPage: currentPage === pageNumber, onClick: onPageClick(pageNumber), pageNumber: pageNumber, totalPages: totalPages }, page));
    });
};

export { PaginationBody };
